query MfaIssueDetails($runId: ConditionID!, $issueId: ConditionID!) {
	issues(run_id_eq: $runId, issue_id_eq: $issueId, deleted_eq: { value: false }) {
		type_name
		description
		severity_name
		screenshot
		scan_name
		knowledge_base_link
		tags__description
		tags__link
		note
		note_creation_time
		viewport_width
		viewport_height
		signature
		elements__accessibility_identifier
		elements__accessibility_label
		elements__element_type
		elements__view_id
		elements__content_description
		elements__class_name
		elements__bounding_box_x
		elements__bounding_box_y
		elements__bounding_box_width
		elements__bounding_box_height
		elements__index
		tickets__key
		tickets__link
	}
	mfa_session_runs(run_id_eq: $runId) {
		user_name
		run_time
	}
}
